import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { AddIcon } from "@/components/assets/icons";

type TProps = {
  title: string;
  icon: any;
  description: string | number;
  openModal?: () => void;
};

const UserInfoDetails: FC<TProps> = ({
  title,
  icon,
  description,
  openModal,
}) => {
  const t = useTranslations();
  const Icon = icon;

  return (
    <div className="flex flex-row gap-[10px]">
      <div className="flex items-center justify-center rounded-lg bg-stone-50 p-[10px]">
        <Icon />
      </div>
      <div>
        <p className="text-nowrap text-xs text-zinc-400">{t(title)}</p>
        <div className="flex flex-row items-center gap-2">
          <p className="text-nowrap text-sm font-semibold text-neutral-900">
            {description}
          </p>
          {openModal && (
            <div
              className="flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full bg-[#f9f9f9] p-1"
              onClick={openModal}
            >
              <AddIcon className="h-5 w-5" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserInfoDetails;
